export default "__VITE_ASSET__Biwg9vek__"